// @flow

import type {Types} from '../typedef';

type ValidateAction = ({ types: Types, endpoint: string }) => void;


const checkIsString = types => types.every(type => typeof type === 'string');


const checkIsFunction = types => types.every(type => typeof type === 'function');
export const validateAction: ValidateAction = ({types, endpoint}) => {
    if (typeof endpoint !== 'string') {
        throw new TypeError('Specify a string endpoint URL.');
    }
    if (!Array.isArray(types) || types.length !== 3) {
        throw new Error('Expected an array of three action types.');
    }
    const isString = checkIsString(types);
    const isFunction = checkIsFunction(types);

    if (!(isString || isFunction)) {
        throw new Error('Expected action type to be strings or function.');
    }
};


            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("../typedef");
